const ONE_DAY_MS = 24 * 60 * 60 * 1000 - 1

/**
 * Match the review cycle for a project submission window.
 */
export function resolveSubmissionCycle(entryDate, submissionDateSec) {
    if (!submissionDateSec || !entryDate || !entryDate.length) {
        return null
    }

    const submissionMs = Number(submissionDateSec) * 1000
    if (isNaN(submissionMs) || submissionMs <= 0) {
        return null
    }

    for (let i = 0; i < entryDate.length; i++) {
        const item = entryDate[i]
        const startDate = item.start_date
        const ddlDate = item.ddl_date + ONE_DAY_MS
        if (submissionMs >= startDate && submissionMs <= ddlDate) {
            return item
        }
    }

    return null
}

export function resolveProjectCycleLabel(entryDate, submissionDateSec) {
    const cycle = resolveSubmissionCycle(entryDate, submissionDateSec)
    return (cycle && cycle.name) ? cycle.name : ''
}

export function resolveAnnounceDateFromSubmission(entryDate, submissionDateSec) {
    const cycle = resolveSubmissionCycle(entryDate, submissionDateSec)
    if (!cycle) {
        return 0
    }
    return cycle.announce_date || 0
}

export function resolveCertDateFromSubmission(entryDate, submissionDateSec) {
    const cycle = resolveSubmissionCycle(entryDate, submissionDateSec)
    if (!cycle) {
        return 0
    }
    return cycle.cert_date || cycle.announce_date || 0
}

export function isResultsPublished(entryDate, submissionDateSec, nowMs) {
    const publishDate = resolveAnnounceDateFromSubmission(entryDate, submissionDateSec)
    if (!publishDate) {
        return false
    }
    const currentTime = nowMs != null ? nowMs : new Date().getTime()
    return currentTime >= publishDate
}
